<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('participants.title')"></page-header-title>

      <v-spacer></v-spacer>

      <!-- WEB SEARCH -->
      <v-checkbox
        v-model="search_params.show_all"
        :label="$t('global.show_all')"
        @change="filter"
        class="mt-8"
        v-if="$vuetify.breakpoint.smAndUp"
      ></v-checkbox>

      <v-text-field
        :label="$t('global.search_start_here')"
        v-model="search_params.any"
        @keydown="checkKeyPress"
        class="mt-8 ml-2"
        v-if="$vuetify.breakpoint.smAndUp"
        autocomplete="new-password"
      ></v-text-field>

      <v-autocomplete
        v-model="search_params.student_group_id"
        :items="studentgroups_filter"
        item-text="name"
        item-value="id"
        :label="$t('studentgroups.title')"
        @change="filter"
        clearable
        class="mt-8 ml-2"
        v-if="$vuetify.breakpoint.smAndUp"
        autocomplete="new-password"
      >
      </v-autocomplete>

      <v-autocomplete
        v-model="search_params.company_id"
        :items="enrolled_organisations_filter"
        item-text="name"
        item-value="id"
        :label="$t('enrolments.title_org')"
        @change="filter"
        clearable
        class="mt-8 ml-2"
        v-if="$vuetify.breakpoint.smAndUp"
        autocomplete="new-password"
      >
      </v-autocomplete>

      <v-select
        v-model="search_params.tenant_user_status"
        :items="[{ key: 'all', text: $t('global.dd_enrolment_list_status_all') }, ...$dd_user_status()]"
        item-text="text"
        item-value="key"
        :label="$t('users.status')"
        @change="filter"
        class="mt-8 ml-2"
        v-if="$vuetify.breakpoint.smAndUp"
      >
      </v-select>

      <v-btn
        class="d-flex-inherit darken-2 cstm-v-btn"
        color="success"
        v-if="selectedParticipants.length > 0"
        @click.stop="courselistpopup_show"
      >
        <v-icon small>fas fa-plus</v-icon>
        <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("enrolments.enrol") }}</span>
      </v-btn>

      <router-link :to="BACKEND_URL + '/participants/create'" v-if="$can('participant-create')">
        <action-button type="new" />
      </router-link>

      <action-button type="filter" @click="show_filter = !show_filter" :icon_only="true" v-if="$vuetify.breakpoint.xsOnly" />
    </v-app-bar>

    <!-- MOBILE SEARCH -->
    <v-expansion-panels :value="0" class="cstm-filter mb-3 elevation-0" v-if="show_filter && $vuetify.breakpoint.xsOnly">
      <v-expansion-panel>
        <v-expansion-panel-content class="elevation-1">
          <v-form ref="form" @submit.prevent="filter">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="search_params.show_all" :label="$t('global.show_all')" @change="filter" hide-details></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('global.search_start_here')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="search_params.student_group_id"
                    :items="studentgroups_filter"
                    item-text="name"
                    item-value="id"
                    :label="$t('studentgroups.title')"
                    @change="filter"
                    clearable
                    autocomplete="new-password"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="search_params.company_id"
                    :items="enrolled_organisations_filter"
                    item-text="name"
                    item-value="id"
                    :label="$t('enrolments.title_org')"
                    @change="filter"
                    clearable
                    autocomplete="new-password"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="search_params.tenant_user_status"
                    :items="[{ key: 'all', text: $t('global.dd_enrolment_list_status_all') }, ...$dd_user_status()]"
                    item-text="text"
                    item-value="key"
                    :label="$t('users.status')"
                    @change="filter"
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="participants"
            :items-per-page="participants.length"
            :options.sync="pagination"
            :footer-props="{
               showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            :show-select="true"
            v-model="selectedParticipants"
            :must-sort="true"
          >
            <template v-slot:item.company_id="{ item }">
              <!--<router-link
                :to="{
                  path: BACKEND_URL + '/enrolments/organisations/view/' + item.company_id,
                  props: { id: item.company_id }
                }"
                v-if="item.company_id"
              >
                {{ item.company_id ? item.company.name : "" }}
              </router-link>-->

              {{ item.companies.map(i => i.name).join(", ") }}
            </template>

            <template v-slot:item.date_of_birth="{ item }">
              {{ item.date_of_birth ? moment.utc(item.date_of_birth).format(DATE_FORMAT) : null }}
            </template>

            <template v-slot:item.tenant_user_status="{ item }">
              {{ $dd_user_status(item.tenant_user_status) }}
            </template>

            <template v-slot:item.groupcode="{ item }">
              <span v-for="(sg, index) in item.student_groups" :key="index">
                <router-link
                  :to="{
                    path: BACKEND_URL + '/studentgroups/edit/' + sg.studentgroup_id,
                    props: { id: sg.studentgroup_id }
                  }"
                >
                  {{ sg.name }}<span v-if="index < item.student_groups.length - 1">, </span>
                </router-link>
              </span>
            </template>

            <template v-slot:item.actions="{ item }" class="test">
              <router-link
                :to="{ path: BACKEND_URL + '/participants/edit/' + item.id, props: { id: item.id } }"
                v-if="$can('participant-edit')"
              >
                <action-button type="edit" :icon_only="true" small />
              </router-link>

              <action-button
                type="delete"
                :icon_only="true"
                @click="del(item.id, item.course_ids)"
                v-if="$hasRole('system-developer')"
                small
              />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>

    <courseListPopup
      :show="showCourseListPopup"
      :status_ids="[1]"
      :number_of_enrolees="selectedParticipants.length"
      :show_course_filter="false"
      :show_coursetype_filter="true"
      :single_select="true"
      @callback_courselistpopup_cancel="callback_courselistpopup_cancel"
      @callback_courselistpopup_submit="callback_courselistpopup_submit"
    />

    <multiEnrolmentFormPopup 
      :key="reRender"
      :show="showMultiEnrolmentFormPopup"
      :course_id="currentCourseID"
      :course_uuid="currentCourseUUID"
      :autofill_data="currentAutoFillData"
      @callback_multienrpopup_submit="callback_multienrpopup_submit"
      @callback_multienrpopup_cancel="callback_multienrpopup_cancel" />
  </v-container>
</template>

<script>
import courseListPopup from "../../courses/partials/CourseListPopup.vue"
import multiEnrolmentFormPopup from "../../enrolments/partials/MultiEnrolmentFomPopup.vue"

export default {
  name: "ParticipantsList",

  components: {
    courseListPopup,
    multiEnrolmentFormPopup
  },

  data() {
    return {
      url: "",
      participants: [],

      showCourseListPopup: false,
      selectedParticipants: [],
      selectedCourses: [],

      showMultiEnrolmentFormPopup: false,
      coursePopupData: null,
      currentAutoFillData: null,
      currentCourseID: null,
      currentCourseUUID: null,
      reRender: 1,

      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
         page: this.$getLocalStorage("__participantListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["first_name"],
        sortDesc: [false]
      },
      search_params: {
        any: "",
        title: "",
        student_group_id: null,
        company_id: null,
        show_all: false
      },

      studentgroups_filter: [],
      enrolled_organisations_filter: []
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("participants.first_name"), value: "first_name" },
          { text: this.$t("participants.last_name"), value: "last_name" },
          { text: this.$t("participants.date_of_birth"), value: "date_of_birth" },
          { text: this.$t("participants.email"), value: "email" },
          { text: this.$t("participants.mobile"), value: "mobile" },
          { text: this.$t("studentgroups.groupcode"), value: "groupcode" },
          { text: this.$t("participants.company_id"), value: "company_id" },
          { text: this.$t("users.status"), value: "tenant_user_status", width: "100px" },
          { text: this.$t("global.actions"), value: "actions", width: "10%", align: "end", sortable: false }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__participantListSearchParams", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__participantListSort", JSON.stringify(obj))
          }
        }

        if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__participantListPage", newVal.page)
          }

        if (this.search_params.any || this.search_params.student_group_id || this.search_params.company_id || this.search_params.show_all) {
          this.refresh = true
        }
      }
    }
  },

  created() {
    this.url = this.API_URL + "participants"

    if (localStorage.getItem("__participantListSearchParams")) {
      this.search_params = JSON.parse(localStorage.getItem("__participantListSearchParams"))
      if (this.search_params.any) {
        this.refresh = true
      }
    }

    this.ddlists()
  },

  methods: {
    list() {
      let localSort = localStorage.getItem("__participantListSort")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      this.show_loading = true

      axios.get(this.url + "?resourcetype=user-basic&" + query).then((res) => {
        this.participants = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    ddlists() {
      axios
        .post(this.API_URL + "request/ddlists", [
          { key: "studentgroups", module: "studentgroups", query: "show_all=true" },
          { key: "enrolled_organisations", module: "enrolled_organisations", query: "show_all=true" }
        ])
        .then((res) => {
          this.studentgroups_filter = res.data.studentgroups
          this.enrolled_organisations_filter = res.data.enrolled_organisations
        })
    },

    filter(target) {
      if (this.search_params.any || this.search_params.student_group_id || this.search_params.company_id || this.search_params.show_all) {
        this.pagination.page = 1
        this.refresh = true
      } else {
        localStorage.setItem("__participantListSearchParams", JSON.stringify(this.search_params))

        this.participants = []
        this.total = 0
        this.refresh = false
        this.show_loading = false
        this.pagination = {
          page: 1,
          itemsPerPage: 0,
          itemsPerPage: this.$getSetting("rows_per_page"),
          sortBy: ["first_name"]
        }
      }
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id, courseids) {
      let vm = this

      if (courseids.length > 0) {
        vm.$awn.alert(vm.$t("participants.cannot_delete_has_enrolment_attendee"))
      } else {
        this.$awn.confirm(
          this.$t("global.delete_message"),
          () => {
            return
          },
          () => {
            axios
              .delete(this.API_URL + "participant/" + id)
              .then((res) => {
                vm.refresh = true
                vm.$awn.success(vm.$t("global.delete_success"))
              })
              .catch((err) => console.log(err))
          },
          {
            labels: {
              confirm: "",
              confirmCancel: this.$t("global.yes"),
              confirmOk: this.$t("global.no")
            }
          }
        )
      }
    },

    courselistpopup_show() {
      this.reRender += 1
      this.showCourseListPopup = true
    },
    callback_courselistpopup_submit(data) {
      this.coursePopupData = data
      this.callback_courselistpopup_cancel()

      let ids = data.map((i) => i.id)
      let uuids = data.map((i) => i.uuid)
      let participants = this.selectedParticipants.map((i) => ({
        id: i.id,
        first_name: i.first_name,
        last_name: i.last_name,
        email: i.email,
        date_of_birth: i.date_of_birth,
        mobile: i.mobile,
        companies: i.companies || [],
      }))

      this.currentAutoFillData = {
        company_id: null,
        company_vat: null,
        participants: participants,
      }
       this.currentCourseID = ids.join(",")
       this.currentCourseUUID = uuids.join(",")
       this.showMultiEnrolmentFormPopup = true
    },
    callback_courselistpopup_cancel() {
      this.showCourseListPopup = false
    },
    coursePopupPostData(data) {
      let vm = this

      if(this.coursePopupData) {
        let ids = this.coursePopupData.map((i) => i.id)
        let pids = data.map((i) => i.participant_id)
        let eids = data.map((i) => i.enrolment_id)

        axios
          .post(this.API_URL + "participant/createAttendee", {
            participant_ids: pids.join(","),
            course_ids: ids.join(","),
            enrolment_ids: eids.join(","),
            site: process.env.VUE_APP_DOMAIN,
            subdomain: vm.SUBDOMAIN
          })
          .then((res) => {
            if (typeof res.data.errors !== "undefined") {
            } else {
              let json = res.data

              if (json.status) {
                vm.$awn.success(json.hasSkipUser ? vm.$t("enrolments.multi_enrolment_successful_with_skip") : vm.$t("global.create_success"))
              } else {
                vm.$awn.alert(vm.$t("enrolments.multi_enrolment_failed"))
              }
            }

            this.selectedParticipants = []
          })
          .catch((err) => console.log(err))
      }
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    },

    callback_multienrpopup_submit(data) {
      if(data) {
        this.coursePopupPostData(data)
      } else {
        this.callback_multienrpopup_cancel()
      }
    },
    callback_multienrpopup_cancel() {
      this.currentAutoFillData = null
       this.currentCourseID = null
       this.currentCourseUUID = null
       this.showMultiEnrolmentFormPopup = false
    },
  }
}
</script>

<style>
/* action column in datatable in mobile */
.v-data-table__mobile-table-row .v-data-table__mobile-row:nth-child(8) {
  height: auto !important;
  padding-bottom: 7px;
}
</style>
